module.exports = __webpack_public_path__ + "static/img/lunbo2.3b1f7667.webp";